import {StockInformationModel} from "../models/domain/stockInformationModel";
import {useProductVariables} from "./useProductVariables";
import {contentService} from "../api/contentService";
import {useSuspenseQuery} from "@apollo/client";

// One hundred and fifty seconds (two and a half minutes)
const pollInterval = 150000;

export const useStockInformationQuery = () => {
    const {variables} = useProductVariables();

    const {error, data} = useSuspenseQuery(contentService.product.stockInformation, {
        errorPolicy: "all",
        variables,
        pollInterval
    });

    const {isTruckShipment, stockInformation} = data?.product ?? {isTruckShipment: false, stockInformation: undefined};
    return {model: stockInformation ? new StockInformationModel(isTruckShipment, stockInformation) : undefined, error}
}